import { render, staticRenderFns } from "./studentTheoryCompetition.vue?vue&type=template&id=5db1e1da&scoped=true"
import script from "./studentTheoryCompetition.vue?vue&type=script&lang=js"
export * from "./studentTheoryCompetition.vue?vue&type=script&lang=js"
import style0 from "./studentTheoryCompetition.vue?vue&type=style&index=0&id=5db1e1da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db1e1da",
  null
  
)

export default component.exports